export default {
    brush: {
        title: 'Børste',
        brushHardness: 'Penselhardhet',
        brushSize: 'Penselstørrelse',
        brushColor: 'Penselfarge',
    },
};
